// extracted by mini-css-extract-plugin
export default {"form":"classes_form__HYmI+","form-container":"classes_form-container__LFeeO","button-container":"classes_button-container__hiXhx"};